/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as UpsellOfferImport } from './routes/upsell-offer'
import { Route as UpsellExploreImport } from './routes/upsell-explore'
import { Route as ReturnInstructionImport } from './routes/return-instruction'
import { Route as RefundMethodImport } from './routes/refund-method'
import { Route as ProductsImport } from './routes/products'
import { Route as ConfirmImport } from './routes/confirm'
import { Route as IndexImport } from './routes/index'
import { Route as ReturnItemIdReturnReasonImport } from './routes/return-item.$id.return-reason'
import { Route as ReturnItemIdExchangeImport } from './routes/return-item.$id.exchange'

// Create/Update Routes

const UpsellOfferRoute = UpsellOfferImport.update({
  id: '/upsell-offer',
  path: '/upsell-offer',
  getParentRoute: () => rootRoute,
} as any)

const UpsellExploreRoute = UpsellExploreImport.update({
  id: '/upsell-explore',
  path: '/upsell-explore',
  getParentRoute: () => rootRoute,
} as any)

const ReturnInstructionRoute = ReturnInstructionImport.update({
  id: '/return-instruction',
  path: '/return-instruction',
  getParentRoute: () => rootRoute,
} as any)

const RefundMethodRoute = RefundMethodImport.update({
  id: '/refund-method',
  path: '/refund-method',
  getParentRoute: () => rootRoute,
} as any)

const ProductsRoute = ProductsImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => rootRoute,
} as any)

const ConfirmRoute = ConfirmImport.update({
  id: '/confirm',
  path: '/confirm',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const ReturnItemIdReturnReasonRoute = ReturnItemIdReturnReasonImport.update({
  id: '/return-item/$id/return-reason',
  path: '/return-item/$id/return-reason',
  getParentRoute: () => rootRoute,
} as any)

const ReturnItemIdExchangeRoute = ReturnItemIdExchangeImport.update({
  id: '/return-item/$id/exchange',
  path: '/return-item/$id/exchange',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/confirm': {
      id: '/confirm'
      path: '/confirm'
      fullPath: '/confirm'
      preLoaderRoute: typeof ConfirmImport
      parentRoute: typeof rootRoute
    }
    '/products': {
      id: '/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof ProductsImport
      parentRoute: typeof rootRoute
    }
    '/refund-method': {
      id: '/refund-method'
      path: '/refund-method'
      fullPath: '/refund-method'
      preLoaderRoute: typeof RefundMethodImport
      parentRoute: typeof rootRoute
    }
    '/return-instruction': {
      id: '/return-instruction'
      path: '/return-instruction'
      fullPath: '/return-instruction'
      preLoaderRoute: typeof ReturnInstructionImport
      parentRoute: typeof rootRoute
    }
    '/upsell-explore': {
      id: '/upsell-explore'
      path: '/upsell-explore'
      fullPath: '/upsell-explore'
      preLoaderRoute: typeof UpsellExploreImport
      parentRoute: typeof rootRoute
    }
    '/upsell-offer': {
      id: '/upsell-offer'
      path: '/upsell-offer'
      fullPath: '/upsell-offer'
      preLoaderRoute: typeof UpsellOfferImport
      parentRoute: typeof rootRoute
    }
    '/return-item/$id/exchange': {
      id: '/return-item/$id/exchange'
      path: '/return-item/$id/exchange'
      fullPath: '/return-item/$id/exchange'
      preLoaderRoute: typeof ReturnItemIdExchangeImport
      parentRoute: typeof rootRoute
    }
    '/return-item/$id/return-reason': {
      id: '/return-item/$id/return-reason'
      path: '/return-item/$id/return-reason'
      fullPath: '/return-item/$id/return-reason'
      preLoaderRoute: typeof ReturnItemIdReturnReasonImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/confirm': typeof ConfirmRoute
  '/products': typeof ProductsRoute
  '/refund-method': typeof RefundMethodRoute
  '/return-instruction': typeof ReturnInstructionRoute
  '/upsell-explore': typeof UpsellExploreRoute
  '/upsell-offer': typeof UpsellOfferRoute
  '/return-item/$id/exchange': typeof ReturnItemIdExchangeRoute
  '/return-item/$id/return-reason': typeof ReturnItemIdReturnReasonRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/confirm': typeof ConfirmRoute
  '/products': typeof ProductsRoute
  '/refund-method': typeof RefundMethodRoute
  '/return-instruction': typeof ReturnInstructionRoute
  '/upsell-explore': typeof UpsellExploreRoute
  '/upsell-offer': typeof UpsellOfferRoute
  '/return-item/$id/exchange': typeof ReturnItemIdExchangeRoute
  '/return-item/$id/return-reason': typeof ReturnItemIdReturnReasonRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/confirm': typeof ConfirmRoute
  '/products': typeof ProductsRoute
  '/refund-method': typeof RefundMethodRoute
  '/return-instruction': typeof ReturnInstructionRoute
  '/upsell-explore': typeof UpsellExploreRoute
  '/upsell-offer': typeof UpsellOfferRoute
  '/return-item/$id/exchange': typeof ReturnItemIdExchangeRoute
  '/return-item/$id/return-reason': typeof ReturnItemIdReturnReasonRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/confirm'
    | '/products'
    | '/refund-method'
    | '/return-instruction'
    | '/upsell-explore'
    | '/upsell-offer'
    | '/return-item/$id/exchange'
    | '/return-item/$id/return-reason'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/confirm'
    | '/products'
    | '/refund-method'
    | '/return-instruction'
    | '/upsell-explore'
    | '/upsell-offer'
    | '/return-item/$id/exchange'
    | '/return-item/$id/return-reason'
  id:
    | '__root__'
    | '/'
    | '/confirm'
    | '/products'
    | '/refund-method'
    | '/return-instruction'
    | '/upsell-explore'
    | '/upsell-offer'
    | '/return-item/$id/exchange'
    | '/return-item/$id/return-reason'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ConfirmRoute: typeof ConfirmRoute
  ProductsRoute: typeof ProductsRoute
  RefundMethodRoute: typeof RefundMethodRoute
  ReturnInstructionRoute: typeof ReturnInstructionRoute
  UpsellExploreRoute: typeof UpsellExploreRoute
  UpsellOfferRoute: typeof UpsellOfferRoute
  ReturnItemIdExchangeRoute: typeof ReturnItemIdExchangeRoute
  ReturnItemIdReturnReasonRoute: typeof ReturnItemIdReturnReasonRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ConfirmRoute: ConfirmRoute,
  ProductsRoute: ProductsRoute,
  RefundMethodRoute: RefundMethodRoute,
  ReturnInstructionRoute: ReturnInstructionRoute,
  UpsellExploreRoute: UpsellExploreRoute,
  UpsellOfferRoute: UpsellOfferRoute,
  ReturnItemIdExchangeRoute: ReturnItemIdExchangeRoute,
  ReturnItemIdReturnReasonRoute: ReturnItemIdReturnReasonRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/confirm",
        "/products",
        "/refund-method",
        "/return-instruction",
        "/upsell-explore",
        "/upsell-offer",
        "/return-item/$id/exchange",
        "/return-item/$id/return-reason"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/confirm": {
      "filePath": "confirm.tsx"
    },
    "/products": {
      "filePath": "products.tsx"
    },
    "/refund-method": {
      "filePath": "refund-method.tsx"
    },
    "/return-instruction": {
      "filePath": "return-instruction.tsx"
    },
    "/upsell-explore": {
      "filePath": "upsell-explore.tsx"
    },
    "/upsell-offer": {
      "filePath": "upsell-offer.tsx"
    },
    "/return-item/$id/exchange": {
      "filePath": "return-item.$id.exchange.tsx"
    },
    "/return-item/$id/return-reason": {
      "filePath": "return-item.$id.return-reason.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
